import PropTypes from 'prop-types';
import { adAudiencesUrl } from 'automation-ui-references/routing/hubspotUrls';
import AdsAudienceMembershipActionMetadata from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceMembershipActionMetadata';
import * as AdsAudienceMembershipActionMetadataKeys from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceMembershipActionMetadataKeys';
import { wireWorkflowAudiences } from 'automation-ui-action-features/actions/ads-audience-membership/adsAudienceResourceQueries';
import { AudienceShape } from 'automation-ui-action-features/actions/ads-audience-membership/propTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILink from 'UIComponents/link/UILink';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
const AdsAudienceMembershipActionDetail = ({
  actionMetadata,
  workflowAudiences,
  isLoadingWorkflowAudiences
}) => {
  const workflowAudience = workflowAudiences.find(audience => audience.targetingAudience.id === actionMetadata.get(AdsAudienceMembershipActionMetadataKeys.AUDIENCE_ID));
  if (!isLoadingWorkflowAudiences && !workflowAudience) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.ads-audience-membership.action-detail.cantFetch"
    });
  }

  /**
   * NOTE(bheng): workflowAudience shouldn't be undefined if isLoading=false,
   *   but TS says it might be 🤷
   */
  const audienceLink = isLoadingWorkflowAudiences || !workflowAudience ? /*#__PURE__*/_jsx(SkeletonText, {}) : /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: adAudiencesUrl(workflowAudience.targetingAudience.id),
    onClick: event => event.stopPropagation(),
    children: workflowAudience.networkState.name
  });
  return actionMetadata.get(AdsAudienceMembershipActionMetadataKeys.SHOULD_ADD) ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.ads-audience-membership.action-detail.shouldAdd",
    options: {
      audienceLink
    }
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.ads-audience-membership.action-detail.shouldRemove",
    options: {
      audienceLink
    }
  });
};
AdsAudienceMembershipActionDetail.propTypes = {
  actionMetadata: PropTypes.instanceOf(AdsAudienceMembershipActionMetadata).isRequired,
  workflowAudiences: PropTypes.arrayOf(AudienceShape.isRequired).isRequired,
  isLoadingWorkflowAudiences: PropTypes.bool.isRequired
};
export default wireWorkflowAudiences(AdsAudienceMembershipActionDetail);